var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links-container"},_vm._l((_vm.links),function(link,index){return _c('div',{key:("link-" + index),staticClass:"link",class:{
		'disabled': !link.name
	},on:{"click":function($event){return _vm.redirectTo(link)}}},[_vm._v(" "+_vm._s(link.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }